import React from "react";
import Layout from "components/Layout";
import Widget from "components/Widget";
import ConditionTable from "components/Table/List";
import SearchBox from "components/Filters/SearchBox";
import EditModal from "./components/EditCondition";
import TableAction from "components/Table/Actions/ActionDropdown";
import AddNewCondition from "./components/AddNewCondition";
import UploadCSV from "components/uploadCSV";
import DeleteConfirm from "components/Modal/DeleteConfirm";
import ShowModal from "components/Modal/ShowModal";
import { Tag } from "antd";
const Condition = () => {
  const columns = [
    {
      title: "Condition ID",
      render: (record) => <span>{record.keyIndex}</span>,
      key: "categoryId",
      width: "120px",
    },
    {
      title: "Name",
      render: (record) => <span>{record.conditionName}</span>,
      key: "symptomName",
      width:'300px'
    },
    {
      title: "Color",
      render: (record) => (
        <>
          {record.communityColor ? (
            <div
              style={{
                height: "20px",
                width: "30px",
                background: record.communityColor,
              }}
            ></div>
          ) : (
            "----"
          )}
        </>
      ),
      key: "color",
    },
    {
      title: "",
      render: (record) => <TableAction menu={renderActions(record)} />,
      key: "action",
      width: "50px",
    },
  ];

  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column">
        <ShowModal
          record={record}
          modalName="EditCondition_Modal"
          buttonName="Edit"
        />
        <DeleteConfirm
          type="deleteCondition"
          method="DELETE"
          selectedItem={record}
          apiRequest="DeleteRecord"
          recordName="conditionsList"
          buttonName="Yes"
          oKText="Delete"
          title="Are you sure you want to delete this Condition?"
          content=""
          Icon="Delete"
        />
      </div>
    );
  };

  return (
    <Layout>
      <Widget
        styleName="mainTable gx-p-0"
        title={
          <div className="gx-d-flex gx-flex-column">
            <span>Conditions</span>
            <a
              className="gx-m-0"
              href="https://painles.s3.amazonaws.com/1653373002628-ConditionSample%20-%20Sheet1.csv"
            >
              <Tag className="gx-m-0" color="blue">
                Download CSV Sample
              </Tag>
            </a>
          </div>
        }
        extra={
          <div className="gx-d-flex" style={{ gap: "20px" }}>
            <SearchBox
              apiName="getConditions"
              recordName="conditionsList"
              requestType="FetchRecord"
              customQuery={{ query: "search", key: "name" }}
              placeholder="Search by name"
              width="200px"
            />
            <UploadCSV
              type="getConditions"
              url="bulkImportEducation"
              recordName="conditionsList"
              table="Condition"
              cb="conditionName"
              uId="conditionId"
            />
            <AddNewCondition />
          </div>
        }
      >
        <ConditionTable
          apiName="getConditions"
          recordName="conditionsList"
          scroll={true}
          pagination={true}
          columns={columns}
        />
      </Widget>
      <EditModal />
    </Layout>
  );
};
export default Condition;
